'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _click_or_escape_outside = require('./click_or_escape_outside.js');

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _button = require('./global_components/button.js');

var _button2 = _interopRequireDefault(_button);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _dropdown_component = require('./global_components/dropdown_component.js');

var _dropdown_component2 = _interopRequireDefault(_dropdown_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _premium_discount_line_chart = require('./charts/premium_discount_line_chart');

var _premium_discount_line_chart2 = _interopRequireDefault(_premium_discount_line_chart);

var _premium_discount_chart = require('./charts/premium_discount_chart.js');

var _premium_discount_chart2 = _interopRequireDefault(_premium_discount_chart);

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var PremiumDiscountChartParent = function (_React$Component) {
  _inherits(PremiumDiscountChartParent, _React$Component);

  function PremiumDiscountChartParent(props) {
    _classCallCheck(this, PremiumDiscountChartParent);

    var _this = _possibleConstructorReturn(this, (PremiumDiscountChartParent.__proto__ || Object.getPrototypeOf(PremiumDiscountChartParent)).call(this, props));

    _this.setBarChartDateFilter = _this.setBarChartDateFilter.bind(_this);
    _this.setLineChartDateFilter = _this.setLineChartDateFilter.bind(_this);
    _this.renderSingleDateOptionBasedOnType = _this.renderSingleDateOptionBasedOnType.bind(_this);
    _this.renderIcon = _this.renderIcon.bind(_this);
    _this.getIconEl = _this.getIconEl.bind(_this);
    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    var defaultPremiumDiscountPeriod = props.premiumDiscountPeriodList[0];
    if (!(0, _ramda.isNil)(defaultPremiumDiscountPeriod)) {
      var defaultSelectedDateOption = (defaultPremiumDiscountPeriod.premiumDiscountPeriodTypeCode === "PY" ? _string_utility2.default.getLocalizedString(_this.props.intl, 'Prior Year', 'pdp-premium-discount-chart-prior-year-label') : defaultPremiumDiscountPeriod.premiumDiscountPeriodTypeCode) + " " + _date_formatter2.default.getDateInSpecificFormat(defaultPremiumDiscountPeriod.premiumDiscountPeriodStartDate, 'YYYY') + " (" + _date_formatter2.default.getDateInSpecificFormat(defaultPremiumDiscountPeriod.premiumDiscountPeriodStartDate, 'MMM DD') + " - " + _date_formatter2.default.getDateInSpecificFormat(defaultPremiumDiscountPeriod.premiumDiscountPeriodEndDate, 'MMM DD') + ")";
      var historicalETFClosingData = _this.props.historicalETFClosingPriceList ? _this.props.historicalETFClosingPriceList : [];
      var filteredHistoricalETFClosingData = _this.getFilteredData(historicalETFClosingData, defaultPremiumDiscountPeriod.premiumDiscountPeriodTypeCode);
      _this.state = {
        selectedDateOptionLineChart: 0,
        selectedDateOptionBarChart: 0,
        selectedDateOptionLineChartValue: defaultSelectedDateOption,
        selectedDateOptionBarChartValue: defaultSelectedDateOption,
        filteredHistoricalETFClosingData: filteredHistoricalETFClosingData
      };
    }
    return _this;
  }

  _createClass(PremiumDiscountChartParent, [{
    key: 'getFilteredData',
    value: function getFilteredData(historicalETFClosingData, defaultPremiumDiscountPeriod) {
      if (!(0, _ramda.isNil)(historicalETFClosingData)) {
        return (0, _ramda.filter)(function (node) {
          return node.periodTypeCode === defaultPremiumDiscountPeriod;
        }, historicalETFClosingData);
      }
      return historicalETFClosingData;
    }
  }, {
    key: 'setBarChartDateFilter',
    value: function setBarChartDateFilter(event) {
      this.trackDateOptionChangeClick("premium discount bar chart", event.target.getAttribute("data-display-value"));
      this.setState({
        selectedDateOptionBarChart: event.target.getAttribute("data-option-value"),
        selectedDateOptionBarChartValue: event.target.getAttribute("data-display-value") });
    }
  }, {
    key: 'setLineChartDateFilter',
    value: function setLineChartDateFilter(event) {
      this.trackDateOptionChangeClick("premium discount line chart", event.target.getAttribute("data-display-value"));
      var filteredData = this.getFilteredData(this.props.historicalETFClosingPriceList, event.target.getAttribute("data-period-value"));
      this.setState({
        selectedDateOptionLineChart: event.target.getAttribute("data-option-value"),
        selectedDateOptionLineChartValue: event.target.getAttribute("data-display-value"),
        filteredHistoricalETFClosingData: filteredData
      });
    }
  }, {
    key: 'renderBP1LabelBelowChart',
    value: function renderBP1LabelBelowChart() {
      return _react2.default.createElement(
        'div',
        { className: 'row font-regular caption text-center padding-bottom-30 margin-top--16' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6 col-sm-6 col-md-6' },
          _string_utility2.default.renderFormattedLabel("MARKET PRICE BELOW NAV", "pdp-premium-discount-chart-market-price-below-nav-label")
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-1 col-sm-1 col-md-1' },
          '0%'
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-3 col-sm-3 col-md-5' },
          _string_utility2.default.renderFormattedLabel("MARKET PRICE AT OR ABOVE NAV", "pdp-premium-discount-chart-market-price-at-or-below-nav-label")
        )
      );
    }
  }, {
    key: 'renderBP4LabelBelowChart',
    value: function renderBP4LabelBelowChart() {
      return _react2.default.createElement(
        'div',
        { className: 'row font-regular caption padding-bottom-25' },
        _react2.default.createElement(
          'div',
          { className: 'col-xlg-6 col-lg-6 text-right' },
          _string_utility2.default.renderFormattedLabel("MARKET PRICE BELOW NAV", "pdp-premium-discount-chart-market-price-below-nav-label")
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xlg-4 col-lg-4 text-left' },
          _string_utility2.default.renderFormattedLabel("MARKET PRICE AT OR ABOVE NAV", "pdp-premium-discount-chart-market-price-at-or-below-nav-label")
        )
      );
    }
  }, {
    key: 'renderIconDisclosure',
    value: function renderIconDisclosure(tooltipId) {
      if (!this.props.disclosures || (0, _ramda.isNil)(this.props.disclosures[tooltipId])) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        null,
        this.props.disclosures[tooltipId]
      );
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(tooltipId) {
      var _this2 = this;

      if (!this.props.disclosures || (0, _ramda.isNil)(this.props.disclosures[tooltipId])) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        { id: 'disclosure-' + tooltipId, tabIndex: 0, className: 'icon-info print-hide',
          role: 'tooltip',
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, tooltipId));
          },
          onClick: function onClick(event) {
            return _this2.handleDisclosureIconClick(event, tooltipId);
          }

        },
        ' '
      );
    }
  }, {
    key: 'handleDisclosureIconClick',
    value: function handleDisclosureIconClick(event, tooltipId) {
      var el = this.getIconEl(tooltipId);
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elPadding = 5;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth + elPadding,
        arrowPosition: elRect.left - elWidth - elPadding - 3
      };

      this.props.tooltip.openTooltip(elOffset, this.props.disclosures[tooltipId], null, true, event);
    }
  }, {
    key: 'getIconEl',
    value: function getIconEl(tooltipId) {
      return document.getElementById('disclosure-' + tooltipId);
    }
  }, {
    key: 'dateFilterOptions',
    value: function dateFilterOptions(type) {
      var _this3 = this;

      var items = [];
      mapIndexed(function (period, index) {

        var dateOption = (period.premiumDiscountPeriodTypeCode === "PY" ? _string_utility2.default.getLocalizedString(_this3.props.intl, 'Prior Year', 'pdp-premium-discount-chart-prior-year-label') : period.premiumDiscountPeriodTypeCode) + " " + _date_formatter2.default.getDateInSpecificFormat(period.premiumDiscountPeriodStartDate, 'YYYY') + " (" + _date_formatter2.default.getDateInSpecificFormat(period.premiumDiscountPeriodStartDate, 'MMM DD') + " - " + _date_formatter2.default.getDateInSpecificFormat(period.premiumDiscountPeriodEndDate, 'MMM DD') + ")";

        items.push(_this3.renderSingleDateOptionBasedOnType(type, index, period, dateOption));
      }, this.props.premiumDiscountPeriodList);
      return items;
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.childRef.focus();
    }
  }, {
    key: 'renderSingleDateOptionBasedOnType',
    value: function renderSingleDateOptionBasedOnType(type, index, period, dateOption) {
      var _this4 = this;

      this[index + 'dropdown'] = _react2.default.createRef();
      if (type === 'bar-chart') {
        return _react2.default.createElement(
          'div',
          { tabIndex: '-1', 'data-option-value': index, 'data-display-value': dateOption, onClick: this.setBarChartDateFilter, className: 'dropdown-list-item', role: 'option',
            ref: this[index + 'dropdown'],
            onKeyDown: function onKeyDown(event) {
              return _accessibility_utility2.default.handleDropdownEvents(_this4, event, '#premiumDiscountDateFilter', index + 'dropdown', '0dropdown', false, function () {
                return _this4.setBarChartDateFilter(event);
              });
            }
          },
          _react2.default.createElement(
            'span',
            { className: 'font-light caption', 'data-option-value': index, 'data-display-value': dateOption },
            dateOption
          )
        );
      } else {
        return _react2.default.createElement(
          'div',
          { tabIndex: '-1', 'data-option-value': index, 'data-display-value': dateOption, onClick: this.setLineChartDateFilter, className: 'dropdown-list-item', role: 'option',
            ref: this[index + 'dropdown'],
            onKeyDown: function onKeyDown(event) {
              return _accessibility_utility2.default.handleDropdownEvents(_this4, event, '#premiumDiscountDateFilter', index + 'dropdown', '0dropdown', false, function () {
                return _this4.setBarChartDateFilter(event);
              });
            } },
          _react2.default.createElement(
            'span',
            { className: 'font-light caption', 'data-option-value': index, 'data-display-value': dateOption, 'data-period-value': period.premiumDiscountPeriodTypeCode },
            dateOption
          )
        );
      }
    }
  }, {
    key: 'trackDownloadButton',
    value: function trackDownloadButton(chartType) {
      var trackingObject = {
        "eventCategory": "pdp",
        "eventAction": '' + chartType,
        "eventLabel": "download chart data"
      };
      _tracking_utility.TrackingUtility.trackEvent(trackingObject);
    }
  }, {
    key: 'trackDateOptionChangeClick',
    value: function trackDateOptionChangeClick(actionLabel, dateDisplayValue) {
      var trackingObject = {
        "eventCategory": "pdp",
        "eventAction": actionLabel,
        "eventLabel": dateDisplayValue
      };
      _tracking_utility.TrackingUtility.trackEvent(trackingObject);
    }
  }, {
    key: 'renderTimePeriodComponent',
    value: function renderTimePeriodComponent(type) {
      var _this5 = this;

      var value = this.state.selectedDateOptionLineChartValue;
      if (type === 'bar-chart') {
        value = this.state.selectedDateOptionBarChartValue;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'row margin-top-20 padding-horizontal-10' },
          _react2.default.createElement(
            'div',
            { className: 'filter col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xlg-3 font-regular caption', role: 'label', id: 'TimePeriod' },
            _string_utility2.default.renderFormattedLabel("TIME PERIOD", "pdp-premium-discount-chart-time-period-label")
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row margin-top-10  padding-horizontal-20' },
          _react2.default.createElement(
            'div',
            { className: '' },
            _react2.default.createElement(
              _click_or_escape_outside2.default,
              { id: 'date-selector', onClose: this.onClose },
              _react2.default.createElement(_dropdown_component2.default, {
                dropdownContent: this.dateFilterOptions(type),
                id: 'premiumDiscountDateFilter',
                className: (this.props.breakpoint < 4 ? "width-percent-100" : "width-percent-25") + ' border-pinkish-grey category row-divider height-45 ',
                breakpoint: this.props.breakpoint,
                initialActiveSelect: value,
                alwaysOpenOnSelect: false,
                ariaLabelledby: 'TimePeriod',
                setRefDropdown: function setRefDropdown(node) {
                  return _this5.childRef = node;
                }
              })
            )
          )
        )
      );
    }
  }, {
    key: 'getExcelServiceURL',
    value: function getExcelServiceURL(chartType) {
      return encodeURI(this.props.gaiaRedirectUrl + '/excel?' + 'type=' + chartType + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.active !== "performance") {
        return null;
      }

      var selectedDateFilter = Number(this.state.selectedDateOptionBarChart);
      var premiumDiscountPeriodFiltered = this.props.premiumDiscountPeriodList[selectedDateFilter];
      var premiumDiscountRangeFiltered = premiumDiscountPeriodFiltered.premiumDiscountPeriodRangeList;
      premiumDiscountRangeFiltered = (0, _ramda.sortBy)((0, _ramda.prop)('order'))(premiumDiscountRangeFiltered);
      var nearZeroPercentage = _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(premiumDiscountRangeFiltered[0].premiumDiscountRangeDayPercentage);
      var nearZeroDays = premiumDiscountRangeFiltered[0].premiumDiscountRangeDayCount;
      premiumDiscountRangeFiltered.shift();

      var greatestDiscount = premiumDiscountPeriodFiltered.minimumDiscountPercentage === 0 ? 'N/A' : _number_utility2.default.convertToEuropeanFormat(premiumDiscountPeriodFiltered.minimumDiscountPercentage, false) + '%';
      var labelBelowChart = this.props.breakpoint < 4 ? this.renderBP1LabelBelowChart() : this.renderBP4LabelBelowChart();
      var title = _string_utility2.default.getLocalizedString(this.props.intl, "Premium Discount", "pdp-premium-discount-chart-header-title", { role: this.props.role });

      return _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: _string_utility2.default.renderFormattedLabel("Premium Discount", "pdp-premium-discount-chart-header-title"),
          headerTitleId: "premium-discount-chart-header",
          headerTitleLabel: "",
          headerLabel: "",
          disclosureText: this.props.disclosures.pdpCardPremiumDiscount,
          placementId: "pdpCardPremiumDiscount"
        },
        this.renderTimePeriodComponent('bar-chart'),
        _react2.default.createElement(
          'div',
          { className: 'row margin-top-15 margin-bottom-20 category row-divider padding-horizontal-20', 'data-testid': 'trading-days' },
          ' ',
          _string_utility2.default.renderFormattedLabel("Trading Days in Period:", "pdp-premium-discount-chart-training-days-label"),
          '\xA0',
          premiumDiscountPeriodFiltered.premiumDiscountPeriodDayCount
        ),
        _react2.default.createElement(_premium_discount_chart2.default, {
          premiumDiscountRangeFiltered: premiumDiscountRangeFiltered,
          numDays: premiumDiscountPeriodFiltered.premiumDiscountPeriodDayCount,
          breakpoint: this.props.breakpoint,
          intl: this.props.intl
        }),
        labelBelowChart,
        _react2.default.createElement(
          'div',
          { className: 'row' },
          ' '
        ),
        _react2.default.createElement(_button2.default, {
          role: this.props.role,
          dataTest: "download-bar-chart-data",
          downloadURL: this.getExcelServiceURL('premiumDiscountChart'),
          dataTestLink: "premiumDiscountBarChart-excel-download-link",
          text: _string_utility2.default.renderFormattedLabel("DOWNLOAD CHART DATA", "pdp-download-chart-data", { role: this.props.role }),
          additionalClassName: "mobile-full-width",
          callBack: this.trackDownloadButton,
          type: "premium discount bar chart",
          ariaLabel: 'Download Chart Data for ' + title
        }),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 padding-right-10 margin-top-5 display-inline-block category row-divider' },
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5' },
            _react2.default.createElement(
              'div',
              { className: 'float-left display-inline-block padding-left-5' },
              _string_utility2.default.renderFormattedLabel("Greatest Premium", "pdp-premium-discount-chart-greatest-premium-label"),
              ' ',
              this.renderIcon("pdpDataPointGreatestPremium")
            ),
            _react2.default.createElement(
              'div',
              { className: 'float-right display-inline-block', 'data-testid': 'maxPremiumPercentage' },
              _number_utility2.default.convertToEuropeanFormat(premiumDiscountPeriodFiltered.maximumPremiumPercentage, false) + '%'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5' },
            _react2.default.createElement('div', { className: 'float-left display-inline-block' }),
            _react2.default.createElement(
              'div',
              { className: 'float-right display-inline-block', 'data-testid': 'maxPremiumDate' },
              _date_formatter2.default.getDateInMonthDayYearFormat(premiumDiscountPeriodFiltered.maximumPremiumValuationDate)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 padding-right-10 margin-top-5 display-inline-block category row-divider' },
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5' },
            _react2.default.createElement(
              'div',
              { className: 'float-left display-inline-block padding-left-5' },
              _string_utility2.default.renderFormattedLabel("Greatest Discount", "pdp-premium-discount-chart-greatest-discount-label"),
              ' ',
              this.renderIcon("pdpDataPointGreatestDiscount")
            ),
            _react2.default.createElement(
              'div',
              { className: 'float-right display-inline-block padding-left-5', 'data-testid': 'minDiscountPercentage' },
              greatestDiscount
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5' },
            _react2.default.createElement('div', { className: 'float-left display-inline-block' }),
            _react2.default.createElement(
              'div',
              { className: 'float-right display-inline-block', 'data-testid': 'minDiscountDate' },
              _date_formatter2.default.getDateInMonthDayYearFormat(premiumDiscountPeriodFiltered.minimumDiscountValuationDate)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 padding-right-10 margin-top-5 display-inline-block category row-divider' },
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5' },
            _react2.default.createElement(
              'div',
              { className: 'float-left display-inline-block padding-left-5' },
              ' ',
              _string_utility2.default.renderFormattedLabel("Days within 0.5% of NAV", "pdp-premium-discount-chart-days-within-point-five-label")
            ),
            _react2.default.createElement(
              'div',
              { className: 'float-right display-inline-block', 'data-testid': 'nearZeroDays' },
              nearZeroDays,
              '/',
              premiumDiscountPeriodFiltered.premiumDiscountPeriodDayCount
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5' },
            _react2.default.createElement('div', { className: 'float-left display-inline-block' }),
            _react2.default.createElement(
              'div',
              { className: 'float-right display-inline-block', 'data-testid': 'nearZeroPercentage' },
              nearZeroPercentage
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 padding-right-10 margin-top-5 display-inline-block category row-divider' },
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5' },
            _react2.default.createElement(
              'div',
              { className: 'float-left display-inline-block padding-left-5' },
              _string_utility2.default.renderFormattedLabel("Days at Premium", "pdp-premium-discount-chart-days-at-premium-label"),
              ' ',
              this.renderIcon("pdpDataPointDaysatPremium")
            ),
            _react2.default.createElement(
              'div',
              { className: 'float-right display-inline-block', 'data-testid': 'premiumDayCount' },
              premiumDiscountPeriodFiltered.premiumDayCount
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 padding-right-10 margin-top-5 margin-bottom-10 display-inline-block category row-divider' },
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5' },
            _react2.default.createElement(
              'div',
              { className: 'float-left display-inline-block padding-left-5' },
              _string_utility2.default.renderFormattedLabel("Days at Discount", "pdp-premium-discount-chart-days-at-discount-label"),
              ' ',
              this.renderIcon("pdpDataPointDaysatDiscount")
            ),
            _react2.default.createElement(
              'div',
              { className: 'float-right display-inline-block', 'data-testid': 'discountDayCount' },
              premiumDiscountPeriodFiltered.discountDayCount
            )
          )
        ),
        this.renderTimePeriodComponent('line-chart'),
        _react2.default.createElement(_premium_discount_line_chart2.default, {
          historicalETFClosingPriceList: this.state.filteredHistoricalETFClosingData,
          breakpoint: this.props.breakpoint
        }),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          ' '
        ),
        _react2.default.createElement(_button2.default, {
          role: this.props.role,
          dataTest: "download-line-chart-data",
          downloadURL: this.getExcelServiceURL('premiumDiscountLineChart'),
          dataTestLink: "premiumDiscountLineChart-excel-download-link",
          text: _string_utility2.default.renderFormattedLabel("DOWNLOAD CHART DATA", "pdp-download-chart-data", { role: this.props.role }),
          additionalClassName: "mobile-full-width",
          callBack: this.trackDownloadButton,
          type: "premium discount line chart",
          ariaLabel: 'Download Chart Data for ' + title
        }),
        _react2.default.createElement(
          'div',
          { 'data-testid': 'premium-discount-print-disclosures', className: 'text-justified font-light caption print-display print-page-break', style: { "display": "none" } },
          _react2.default.createElement(
            'div',
            { className: 'margin-bottom-15 text-justified font-slate-grey print-page-break' },
            this.renderIconDisclosure("pdpDataPointGreatestPremium")
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-bottom-15 text-justified font-slate-grey print-page-break' },
            this.renderIconDisclosure("pdpDataPointGreatestDiscount")
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-bottom-15 text-justified font-slate-grey print-page-break' },
            this.renderIconDisclosure("pdpDataPointDaysatPremium")
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-bottom-15 text-justified font-slate-grey print-page-break' },
            this.renderIconDisclosure("pdpDataPointDaysatDiscount")
          )
        )
      );
    }
  }]);

  return PremiumDiscountChartParent;
}(_react2.default.Component);

exports.default = PremiumDiscountChartParent;